import Vuex from 'vuex'
import Vue from 'vue'
import Toasted from 'vue-toasted'
import auth from './modules/auth'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
Vue.use(Toasted, { duration: 3000, position: 'top-right' })

export default new Vuex.Store({
  modules: {
    auth
  },
  plugins: [new VuexPersistence().plugin]
})
